import type { IntentTemplate } from "../types";
import { formatCountSummary, getArrayLength } from "./shared";

export const CONFIG_INTENT_TEMPLATES = {
  COMMIT_CONFIG_CHANGE: {
    label: "Configuration",
    pendingTitle: "Review Configuration Change",
    summary: (payload) => {
      const category = typeof payload.category === "string" ? payload.category : "config";
      const key = typeof payload.key === "string" ? payload.key : "setting";
      return `Configuration ${category}.${key} will be updated.`;
    },
    fieldLabels: {
      category: "Category",
      key: "Key",
      value: "Value",
    },
  },
  UPDATE_OPERATING_HOURS: {
    label: "Operating Hours",
    pendingTitle: "Review Operating Hours Changes",
    summary: (payload) => formatCountSummary(getArrayLength(payload.operatingHours), "day", "days"),
    fieldLabels: {
      operatingHours: "Operating Hours",
    },
  },
  UPDATE_SALON_PROFILE: {
    label: "Salon Profile",
    pendingTitle: "Review Salon Profile Changes",
    summary: () => "Salon profile details will be updated.",
    fieldLabels: {
      name: "Salon Name",
      address: "Address",
      additionalAddressInfo: "Additional Address",
      city: "City",
      state: "State",
      zipCode: "ZIP Code",
      country: "Country",
      publicDescription: "Public Description",
    },
  },
  UPDATE_SALON_CONTACT: {
    label: "Salon Contact",
    pendingTitle: "Review Contact Updates",
    summary: (payload) =>
      formatCountSummary(getArrayLength(payload.contacts), "contact", "contacts"),
    fieldLabels: {
      contacts: "Contacts",
    },
  },
  CREATE_HOLIDAY: {
    label: "Holiday",
    pendingTitle: "Review New Holiday",
    summary: (payload) => {
      const name = typeof payload.name === "string" ? payload.name : "Holiday";
      return `A new holiday (${name}) will be created.`;
    },
    fieldLabels: {
      name: "Name",
      message: "Message",
      startDateTime: "Start",
      endDateTime: "End",
      blockOnlineBooking: "Block Online Booking",
      scope: "Scope",
    },
  },
  UPDATE_HOLIDAY: {
    label: "Holiday",
    pendingTitle: "Review Holiday Update",
    summary: () => "An existing holiday will be updated.",
    fieldLabels: {
      id: "Holiday ID",
      name: "Name",
      message: "Message",
      startDateTime: "Start",
      endDateTime: "End",
      blockOnlineBooking: "Block Online Booking",
      scope: "Scope",
      isActive: "Active",
    },
  },
  CREATE_TEAM_MEMBER: {
    label: "Team",
    pendingTitle: "Review New Team Member",
    summary: (payload) => {
      const name = typeof payload.displayName === "string" ? payload.displayName : "team member";
      return `A new team member (${name}) will be created.`;
    },
    fieldLabels: {
      displayName: "Display Name",
      email: "Email",
      salonRole: "Role",
      canAcceptOnlineBookings: "Can Accept Online Bookings",
      bio: "Bio",
    },
  },
  UPDATE_TEAM_MEMBER: {
    label: "Team",
    pendingTitle: "Review Team Member Update",
    summary: () => "Team member settings will be updated.",
    fieldLabels: {
      id: "Member ID",
      displayName: "Display Name",
      bio: "Bio",
      canAcceptOnlineBookings: "Can Accept Online Bookings",
      isActive: "Active",
      color: "Color",
    },
  },
  UPDATE_WORKER_SERVICE_RESTRICTIONS: {
    label: "Worker Restrictions",
    pendingTitle: "Review Worker Restrictions",
    summary: (payload) => {
      const mode =
        typeof payload.restrictionMode === "string" ? payload.restrictionMode : "UNKNOWN";
      return `Worker service restriction mode will be set to ${mode}.`;
    },
    fieldLabels: {
      workerSalonId: "Worker Salon ID",
      workerId: "Worker ID",
      restrictionMode: "Restriction Mode",
      serviceIds: "Service IDs",
      categoryIds: "Category IDs",
    },
  },
} satisfies Record<string, IntentTemplate>;
